import styled from 'styled-components';

import Heading, { HeadingProps } from '../Heading';

export type H6Props = Omit<HeadingProps, 'tagName'>;

const H6 = styled(Heading).attrs({
  tagName: 'h6',
})``;

H6.displayName = 'H6';

export default H6;
